/* eslint-disable eslint-js/no-restricted-syntax */
/**
 * @deprecated - use platform Form instead
 */
import {AnyObjectSchema} from 'yup';

import {ComponentClass, ReactElement} from 'react';
import {FormRenderProps as FinalFormRenderProps} from 'react-final-form';

import type {UsePriceCalculation} from '../../../components/FinalForm/hooks/usePriceCalculation';
import type {PossibleObject} from '../../../types/PossibleObject';
import type {ConditionProps} from '../components/Condition';
import type {FormFieldArrayProps} from '../components/FormFieldArray';
import type {SubscribeProps} from '../components/Subscribe';
import type {FieldName} from '../types/FieldName';
import type {FormApi} from '../types/FormApi';
import type {FormFieldType} from './FormFieldType';

/**
 * @deprecated - use platform Form instead
 */
export type FormRenderProps<
  FormValues extends PossibleObject = undefined,
  InitialFormValues extends PossibleObject = undefined,
  Context extends PossibleObject = undefined,
> = FinalFormRenderProps<FormValues, InitialFormValues> & {
  form?: FormApi<FormValues, InitialFormValues>;
  /** Field component with property names of the FormValues object */
  /**
   * @deprecated - use platform FormField instead
   */
  Field: FormFieldType<FormValues, Context>;
  /** Subscribe component is used to listen to other fields value */
  /**
   * @deprecated - use platform FormField instead
   */
  // eslint-disable-next-line typescript/no-explicit-any -- Pre-existing any
  Subscribe: <V = any>(
    props: SubscribeProps<FormValues, Context, V>
  ) => ReactElement<SubscribeProps<FormValues, Context, V>>;
  /** Condition component with property names of the FormValues object */
  /**
   * @deprecated - use platform FormField instead
   */
  Condition: ComponentClass<ConditionProps<FormValues>>;
  /** FieldArray component with property names of the FormValues object */
  /**
   * @deprecated - use platform FormField instead
   */
  FieldArray: <T extends PossibleObject = undefined>(
    props: FormFieldArrayProps<T, FormValues>
  ) => ReactElement<FormFieldArrayProps<T, FormValues>>;
  validateAfterSubmit?: boolean;
  schema?: AnyObjectSchema;
  usePriceCalculation: <
    FormValues extends PossibleObject = undefined,
    InitialFormValues extends PossibleObject = undefined,
  >(
    form: FormApi<FormValues, InitialFormValues>,
    name: FieldName<FormValues>
  ) => UsePriceCalculation;
};
